<button class="primary-button" [disabled]="isDisabled" (click)="presentActionSheet()">
    <span *ngIf="!loading">Upload Defect Photo</span>
    <ion-spinner name="dots" *ngIf="loading"></ion-spinner>
</button>
